<template>
  <div class="container-fluid">
    <div
      class="d-flex flex-wrap flex-column flex-sm-row justify-content-between"
    >
      <div>
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Create new Campaign
        </div>
        <div class="d-flex align-items-center w-100 cursor-pointer">
          <BackRoute />
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 px-0 col-md-7 mt-5">
        <!-- Campaign Form -->
        <div class="p-5 col-md-12 border-radius-8" style="background: #f9faff">
          <el-form
            :model="campaignForm"
            :rules="rules"
            ref="campaignFormRef"
            label-position="top"
            class="campaign-form"
          >
            <el-form-item label="" prop="Name" class="mb-3">
              <div class="form-label">Campaign Name</div>
              <el-input
                v-model="campaignForm.name"
                placeholder="Enter campaign name"
                class="w-100"
              />
              <small class="text-muted mt-1 d-block">
                This will be visible to users.
              </small>
            </el-form-item>

            <el-form-item label="" prop="description" class="mb-3">
              <div class="form-label">Campaign Description</div>
              <el-input
                v-model="campaignForm.description"
                placeholder="Provide a brief description"
                class="w-100"
              />
              <small class="text-muted mt-1 d-block"
                >Keep it succinct and informative.</small
              >
            </el-form-item>

            <div class="form-group mb-4">
              <div class="form-label">Campaign Goal</div>
              <div class="goal-display bg-white rounded p-3 text-right mt-1">
                <span class="h2 fw-400 text-dark">
                  <!-- {{ formatCurrency(campaignForm.goal) }} -->
                  250,000,000
                </span>
              </div>
            </div>

            <!-- Campaign Goal -->
            <!-- <el-form-item label="Campaign Goal" prop="goal" class="mb-4">
              <el-input-number
                v-model="campaignForm.goal"
                :min="1"
                :max="999999999"
                :step="1000"
                
                class="w-100 mt-2"
                controls-position="right"
              />
            </el-form-item> -->

            <!-- Start Date -->
            <el-form-item label="" prop="startDate" class="mb-3">
              <div class="form-label">Start Date</div>
              <el-date-picker
                v-model="campaignForm.startDate"
                type="date"
                size="large"
                placeholder="Select start date"
                class="w-100"
                format="dd MMM yyyy"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>

            <!-- Stop Date -->
            <el-form-item label="" prop="stopDate" class="mb-4">
              <div class="form-label">Stop Date</div>
              <el-date-picker
                v-model="campaignForm.stopDate"
                type="date"
                size="large"
                placeholder="YYYY-MM-DD"
                class="w-100"
                format="dd MMM yyyy"
                value-format="yyyy-MM-dd"
              />
              <small class="text-muted mt-1 d-block">
                Choose when the campaign should end
              </small>
            </el-form-item>

            <div class="form-group mb-4">
              <div class="form-label">Media Type</div>
              <el-radio-group v-model="campaignForm.mediaType" class="d-flex">
                <el-radio label="image" class="mr-4">Image</el-radio>
                <el-radio label="video" class="mr-4">Video</el-radio>
                <el-radio label="gif">GIF</el-radio>
              </el-radio-group>
              <small class="text-muted mt-1 d-block">
                Select the type of media you want to include
              </small>
            </div>

            <!-- Media Upload -->
            <el-form-item class="mb-4">
              <el-upload
                class="upload-demo w-100"
                drag
                :action="uploadAction"
                :on-success="handleUploadSuccess"
                :before-upload="beforeUpload"
                :show-file-list="false"
              >
                <div class="upload-area border-0 text-center">
                  <i
                    class="el-icon-picture-outline text-muted"
                    style="font-size: 48px"
                  ></i>
                  <div class="text-muted mt-2">
                    <p class="mb-0">Drop files here or click to upload</p>
                  </div>
                </div>
              </el-upload>
            </el-form-item>

            <!-- Notification Settings -->
            <el-form-item class="mb-4">
              <el-checkbox v-model="campaignForm.notifyOnPayment">
                Notify when someone pays
              </el-checkbox>
            </el-form-item>

            <!-- Payment Gateway Selection -->
            <div class="form-group">
              <label class="form-label"
                >Select payment gateway or channel</label
              >

              <div class="row">
                <div class="col-12">
                  <div
                    class="payment-option text-dak mb-3"
                    :class="{
                      active: selectedPaymentOption === 'default',
                    }"
                    @click="selectDefaultPayment"
                  >
                    <el-radio v-model="selectedPaymentOption" label="default">
                      <span class="text-dak text-wrap">
                        Default ChurchPlus Payment Gateway</span
                      >
                    </el-radio>
                    <!-- <span class="mt-3">
                              </span
                            > -->
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div
                    class="payment-option text-dak"
                    :class="{
                      active: selectedPaymentOption === 'custom',
                    }"
                    @click="selectCustomPayment"
                  >
                    <el-radio v-model="selectedPaymentOption" label="custom">
                      <span class="text-dak text-wrap">
                        Or Connect your Payment gateway</span
                      >
                    </el-radio>
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="text-center col-md-12 px-0 mt-5">
              <el-button
                size="large"
                :color="primarycolor"
                @click="createCampaign"
                :loading="isSubmitting"
                class="w-100"
                style="
                  background-color: #2563eb;
                  border-color: #2563eb;
                  border-radius: 25px;
                "
              >
                Create Campaign
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="openCampaingSuccess"
      title=""
      :width="mdAndUp || lgAndUp || xlAndUp ? `40%` : `90%`"
      :show-close="true"
      class="border-radius-20"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 d-flex justify-content-center mb-4">
            <div>
              <img style="width: 50px; height: 50px;" src="../../../assets/celebration-spark.png" alt="" />
            </div>
          </div>
          <div class="col-md-12 d-flex justify-content-center mb-2">
            <div class="text-black">Great, You’ve created a Campaign.</div>
          </div>
          <div class="col-md-12 d-flex justify-content-center mb-2">
            <div class="text-black s-20 fw-500">Kids Health Care Mission</div>
          </div>
          <div class="col-md-12 justify-content-center d-flex mb-4">
            <div
              class="col-11 col-md-7 justify-content-center border-radius-8 px-3 py-3 d-flex"
              style="background-color: #ebedff"
            >
              <div class="mr-2"><CopyIcon class="w-12 h-12" /></div>
              <div style="color: #0e4cb5" class="s-16">Copy Campaign link</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- Connect Payment Gateway Modal -->
    <el-dialog
      v-model="thirdTemplate"
      title=""
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
      :close-on-click-modal="false"
      :show-close="true"
      class="border-radius-20"
      @close="closeThirdModal"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 text-center text-dak font-weight-600 s-20">
            Choose or connect a Payment Gateway
          </div>
          <div class="col-md-12 mt-2 px-0"><hr class="w-100" /></div>
        </div>
        <!-- Selected Connected Gateways -->
        <div class="row mt-3">
          <div class="col-12">
            <div class="form-group">
              <label class="form-label">Select Connected Gateways</label>
              <el-select
                v-model="selectedConnectedGateway"
                placeholder=""
                class="w-100 connected-gateway-select"
              >
                <el-option
                  v-for="(gateway, index) in connectedGateways"
                  :key="index"
                  :label="gateway.name"
                  :value="gateway.id"
                />
                <div
                  class="w-100 py-1 cursor-pointer text-center primary--text font-weight-600 d-flex align-items-center justify-content-center"
                >
                  <el-icon><Plus /></el-icon>
                  <span>add Gateway</span>
                </div>
              </el-select>
              <div
                class="w-100 mt-1 cursor-pointer text-center primary--text font-weight-600 d-flex align-items-center justify-content-end"
              >
                <el-icon><Plus /></el-icon>
                <span>add Gateway</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Connect a Payment Gateway -->
        <div class="row">
          <div class="col-12">
            <div class="connect-section">
              <h3 class="section-title">Connect a Payment Gateway</h3>

              <div class="gateway-list">
                <!-- Stripe -->
                <div class="row">
                  <div class="col-12">
                    <div class="gateway-connect-item">
                      <div class="row w-100">
                        <div class="col-md-8">
                          <div class="gateway-info">
                            <img
                              src="../../../assets/stripe.png"
                              alt="Stripe"
                              class="gateway-icon"
                            />
                            <!-- <div class="stripe-logo">stripe</div> -->
                          </div>
                        </div>
                        <div class="col-md-4 text-right">
                          <el-button
                            type="text"
                            class="connect-btn"
                            @click="connectGateway('stripe')"
                          >
                            Connect
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Flutterwave -->
                <div class="row">
                  <div class="col-12">
                    <div class="gateway-connect-item">
                      <div class="row align-items-center w-100">
                        <div class="col-8">
                          <div class="gateway-info">
                            <img
                              src="../../../assets/Full-Flutterwave.png"
                              alt="Flutterwave"
                              class="gateway-icon"
                              style="width: 10rem !important"
                            />
                            <!-- <span class="gateway-name-large">Flutterwave</span> -->
                          </div>
                        </div>
                        <div class="col-4 text-right">
                          <el-button
                            type="text"
                            class="connect-btn"
                            @click="connectGateway('flutterwave')"
                          >
                            Connect
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Paystack -->
                <div class="row">
                  <div class="col-12">
                    <div class="gateway-connect-item">
                      <div class="row align-items-center w-100">
                        <div class="col-8">
                          <div class="gateway-info">
                            <img
                              src="../../../assets/4PaystackLogo.png"
                              alt="Paystack"
                              class="gateway-icon"
                              style="width: 10rem !important"
                            />
                            <!-- <span class="gateway-name-large">paystack</span> -->
                          </div>
                        </div>
                        <div class="col-4 text-right">
                          <el-button
                            type="text"
                            class="connect-btn"
                            @click="connectGateway('paystack')"
                          >
                            Connect
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="dialog-footer">
                <el-button
                  round
                  :color="primarycolor"
                  class="text-white py-4 w-100"
                  @click="saveGatewaySelection"
                >
                  Save
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
    <!-- ChurchPlus Payment Modal -->
    <el-dialog
      v-model="secondTemplate"
      title=""
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
      :close-on-click-modal="false"
      :show-close="true"
      class="border-radius-20"
      @close="closeSecondModal"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 text-center text-dak font-weight-600 s-20">
            ChurchPlus Payment Details
          </div>
          <div class="col-md-12 mt-2 px-0"><hr class="w-100" /></div>
        </div>
        <el-form label-position="top" class="px-3">
          <!-- Choose Bank -->
          <div class="row mt-2">
            <div class="col-12">
              <div class="form-group">
                <label class="form-label">Choose Bank</label>
                <el-select
                  v-model="selectedBankID"
                  filterable
                  placeholder="Choose Bank"
                  class="w-100"
                  @change="setSelectedBank"
                >
                  <el-option
                    v-for="(bank, index) in filteredBanks"
                    :key="index"
                    :label="bank.name"
                    :value="bank.id"
                  />
                </el-select>
              </div>
            </div>
          </div>

          <!-- Account Number -->
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="form-label">Account Number</label>
                <el-input
                  v-model="accountNumber"
                  placeholder="Account number"
                  class="w-100"
                  @blur="resolveCustomerDetail"
                />
              </div>
            </div>
          </div>

          <!-- Account Name -->
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="form-label">Account Name</label>
                <el-input
                  v-model="accountName"
                  placeholder="Account name"
                  class="w-100 account-name-input"
                  disabled
                />
                <small class="helper-text"
                  >This will automatically come up</small
                >
              </div>
            </div>
          </div>

          <!-- Payment Gateways -->
          <div class="row">
            <div class="col-md-4 col-12 mb-3">
              <div class="col-md-12">
                <el-checkbox v-model="paystackChecked" class="gateway-checkbox">
                  <div class="gateway-info">
                    <img
                      src="../../../assets/4PaystackLogo.png"
                      alt="Paystack"
                      class="gateway-logo w-100"
                    />
                    <!-- <span class="gateway-name">paystack</span> -->
                  </div>
                </el-checkbox>
              </div>
            </div>
            <div class="col-md-4 col-12 mb-3">
              <div class="col-md-12">
                <el-checkbox
                  v-model="flutterwaveChecked"
                  class="gateway-checkbox"
                >
                  <div class="gateway-info">
                    <img
                      src="../../../assets/Full-Flutterwave.png"
                      alt="Flutterwave"
                      class="gateway-logo w-100"
                    />
                    <!-- <span class="gateway-name">Flutterwave</span> -->
                  </div>
                </el-checkbox>
              </div>
            </div>
            <div class="col-md-4 col-12 mb-3">
              <div class="col-md-12">
                <el-checkbox v-model="alaPayChecked" class="gateway-checkbox">
                  <div class="gateway-info">
                    <img
                      src="../../../assets/alat_logo.png"
                      alt="ALA PAY"
                      class="gateway-logo w-100"
                    />
                    <!-- <span class="gateway-name">ALA PAY</span> -->
                  </div>
                </el-checkbox>
              </div>
            </div>
          </div>
        </el-form>
      </div>

      <template #footer>
        <div class="container-fluid px-3">
          <div class="row">
            <div class="col-12">
              <div class="dialog-footer">
                <el-button
                  round
                  :color="primarycolor"
                  class="w-100 py-4 text-white"
                  @click="continueToPayment"
                >
                  Continue to Pay
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, inject } from "vue";
import { ElMessage } from "element-plus";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import CopyIcon from "../../../components/icons/CopyIcon.vue";

// Form data
const campaignForm = reactive({
  name: "",
  description: "",
  goal: 250000000,
  startDate: "",
  stopDate: "",
  mediaType: "image",
  notifyOnPayment: false,
  paymentGateway: "default",
});
const primarycolor = inject("primarycolor");
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();

// Form validation rules
const rules = {
  name: [
    { required: true, message: "Please enter campaign name", trigger: "blur" },
  ],
  description: [
    {
      required: true,
      message: "Please enter campaign description",
      trigger: "blur",
    },
  ],
  goal: [
    { required: true, message: "Please set campaign goal", trigger: "blur" },
  ],
  startDate: [
    { required: true, message: "Please select start date", trigger: "change" },
  ],
  stopDate: [
    { required: true, message: "Please select stop date", trigger: "change" },
  ],
  mediaType: [
    { required: true, message: "Please select media type", trigger: "change" },
  ],
  paymentGateway: [
    {
      required: true,
      message: "Please select payment gateway",
      trigger: "change",
    },
  ],
};

// Refs
const campaignFormRef = ref();
const selectedPaymentOption = ref("");
const selectedConnectedGateway = ref("");
const selectedBank = ref({});
const accountNumber = ref("");
const nigerianBanks = ref([]);
const secondTemplate = ref(false);
const thirdTemplate = ref(false);
const isSubmitting = ref(false);
const openCampaingSuccess = ref(false);
const uploadAction = ref("#"); // Replace with actual upload endpoint
const connectedGateways = ref([
  { name: "FLuttewave", id: 1 },
  { name: "Sendit", id: 2 },
]);

// Methods
const getBanks = () => {
  axios
    .get("/api/Financials/GetBanks")
    .then((res) => {
      console.log(res);
      nigerianBanks.value = res.data;
      getEditPayment();
    })
    .catch((err) => {
      console.log(err);
    });
};
getBanks();
const filteredBanks = computed(() => nigerianBanks.value);
const resolveCustomerDetail = async () => {
  if (!accountNumber.value || !selectedBank.value) return;

  try {
    const res = await axio.post(
      "https://api.ravepay.co/flwv3-pug/getpaidx/api/resolve_account",
      {
        recipientaccount: accountNumber.value,
        destbankcode: selectedBank.value.code,
        PBFPubKey: process.env.VUE_APP_FLUTTERWAVE_PUBLIC_KEY_LIVE,
      }
    );
    accountName.value = res.data.data.data.accountname;
  } catch (error) {
    finish();
    console.log(error);

    loading.value = false;
    if (!accountNumber.value || accountNumber.value === "") {
      ElNotification({
        type: "warning",
        message: "Please enter your account number",
        duration: 3000,
      });
    } else if (!accountName.value || accountName.value === "") {
      ElNotification({
        type: "error",
        message: "Your detail were not found",
        duration: 3000,
      });
    } else {
      ElNotification({
        type: "error",
        message: "Please check your banks details again",
        duration: 3000,
      });
    }
  }
};

const connectGateway = (gatewayName) => {
  ElNotification.success(`Connecting to ${gatewayName}...`);
};
const handleUploadSuccess = (response, file) => {
  ElMessage.success("File uploaded successfully");
};

const beforeUpload = (file) => {
  const isValidType = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "video/mp4",
  ].includes(file.type);
  const isLt10M = file.size / 1024 / 1024 < 10;

  if (!isValidType) {
    ElMessage.error("Please upload valid media file!");
    return false;
  }
  if (!isLt10M) {
    ElMessage.error("File size cannot exceed 10MB!");
    return false;
  }
  return true;
};

const createCampaign = async () => {
  try {
    const valid = await campaignFormRef.value.validate();
    if (valid) {
      isSubmitting.value = true;

      // Simulate API call
      setTimeout(() => {
        ElMessage.success("Campaign created successfully!");
        isSubmitting.value = false;
        // Reset form or navigate to campaigns list
      }, 2000);
    }
  } catch (error) {
    console.log("Validation failed:", error);
  }
};
</script>

<style scoped>
.payment-option {
  background: #d9ebef;
  border-radius: 11px;
  padding: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.payment-option:hover {
  background: #d6ebfa;
}

.payment-option.active {
  background: #d9ebef;
}
.campaign-form .el-form-item__label {
  font-weight: 500 !important;
  color: #111111 !important;
  margin-bottom: 8px;
}

.goal-display {
  border: 1px solid #e5e7eb;
  color: #505050;
}

.upload-area {
  border: 3px dashed #d1d5db;
  transition: border-color 0.3s ease;
}

.upload-area:hover {
  border-color: #2563eb;
}

.payment-option {
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.payment-option:hover {
  border-color: #2563eb;
}

.el-radio {
  margin-right: 0;
}

.el-button--primary {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.min-vh-100 {
  min-height: 100vh;
}
.form-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #000000;
  /* margin-bottom: 0.5rem; */
  display: block;
}
</style>
